import { useQuery } from "@tanstack/react-query";
import { listAssignments, type TmAssignment } from "../api/tm";

/** Index taskId → assignments, chargé en batch pour les vues transverses
 * (Assignées à moi, Équipe, Board).
 * ponytail: N requêtes parallélisées par lots de 8 — remplacer par un endpoint
 * batch TM si l'inventaire dépasse quelques centaines de tâches. */
export function useAssignmentsIndex(taskIds: string[]) {
  return useQuery({
    queryKey: ["tm", "assignments-index", [...taskIds].sort().join(",")],
    enabled: taskIds.length > 0,
    staleTime: 30_000,
    queryFn: async () => {
      const out: Record<string, TmAssignment[]> = {};
      const batch = 8;
      for (let i = 0; i < taskIds.length; i += batch) {
        const slice = taskIds.slice(i, i + batch);
        const results = await Promise.all(
          slice.map((id) =>
            listAssignments(id).then(
              (r) => [id, r.items] as const,
              () => [id, [] as TmAssignment[]] as const,
            ),
          ),
        );
        for (const [id, items] of results) out[id] = items;
      }
      return out;
    },
  });
}
